<script>
export default {
  props: {
    label: { type: String, default: '' },
    color: { type: String, default: '#7cb5ec' },
    checked: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      checkedBgColor: 'background: ' + this.color,
      uncheckedBgColor: 'background: white',
      checkedLabelColor: 'color: #707070',
      uncheckedLabelColor: 'color: #707070',
      // isChecked: this.checked,
    }
  },
  methods: {
    afterClick() {
      // this.isChecked = !this.isChecked
      this.$emit('click')
    },
  },
}
</script>

<template>
  <div class="custom-checkbox">
    <div
      :style="checked?checkedBgColor:uncheckedBgColor"
      @click="disabled?'':afterClick()"/>
    <label
      :style="checked?checkedLabelColor:uncheckedLabelColor"
      @click="disabled?'':afterClick()"
    >{{ label }}</label>
  </div>
</template>

<style scoped>
.custom-checkbox {
  position: relative;
  width: 80%;
}
.custom-checkbox > div {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid #ccc;
  position: absolute;
  top: 3px;
  border-radius: 3px;
}
.custom-checkbox > label {
  font-size: 12px;
  font-size: 0.875em;
  display: inline-block;
  line-height: 18px;
  left: 22px;
  position: relative;
}
/* .custom-checkbox > label:hover {
  font-weight: bold;
  color: black;
} */
</style>
